const API_URL = 'https://api.saba-holding.com/';
// const API_URL = 'http://192.168.1.179:3300/';

export const localStorageName = 'name-website-auth';
export default API_URL;
